import { render, staticRenderFns } from "./404.vue?vue&type=template&id=74ae2b9a&lang=pug&"
import script from "./404.vue?vue&type=script&lang=coffee&"
export * from "./404.vue?vue&type=script&lang=coffee&"
import style0 from "./404.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports